var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5583 13.0399V21.1941C30.5583 26.0707 27.7717 28.1607 23.5917 28.1607H9.67418C8.96168 28.1607 8.28085 28.0974 7.64751 27.9549C7.25168 27.8916 6.87169 27.7808 6.52336 27.6541C4.14836 26.7674 2.70752 24.7091 2.70752 21.1941V13.0399C2.70752 8.16318 5.49418 6.07324 9.67418 6.07324H23.5917C27.1384 6.07324 29.6875 7.5774 30.3684 11.0132C30.4792 11.6466 30.5583 12.2957 30.5583 13.0399Z",
    stroke: "#00B05C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.31 17.7903V25.9445C35.31 30.8212 32.5233 32.9111 28.3433 32.9111H14.4258C13.2542 32.9111 12.1934 32.7529 11.275 32.4045C9.39085 31.7079 8.10834 30.267 7.64917 27.9554C8.2825 28.0979 8.96333 28.1611 9.67583 28.1611H23.5933C27.7733 28.1611 30.56 26.0712 30.56 21.1945V13.0403C30.56 12.2961 30.4967 11.6312 30.37 11.0137C33.3783 11.647 35.31 13.7686 35.31 17.7903Z",
    stroke: "#00B05C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6227 21.3049C18.9312 21.3049 20.8027 19.4334 20.8027 17.1248C20.8027 14.8163 18.9312 12.9448 16.6227 12.9448C14.3141 12.9448 12.4426 14.8163 12.4426 17.1248C12.4426 19.4334 14.3141 21.3049 16.6227 21.3049Z",
    stroke: "#00B05C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56836 13.6416V20.6083",
    stroke: "#00B05C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6843 13.6421V20.6088",
    stroke: "#00B05C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneys);
export default __webpack_public_path__ + "1a463efb1ad743ee9a854a60e8376b51.svg";
export { ForwardRef as ReactComponent };